<template>
    <transition name="fade">
        <div component="VideoGalleryPlayer" v-if="getActorVideoPlaying">
            <btn class="close" color="ghostWhite" size="icon" :icon="'close'" @click.stop="close" />
            <video
                ref="video"
                width="100%"
                :controls="getActorVideoPlaying.controls !== false"
                :loop="getActorVideoPlaying.loop"
                autoplay
            >
                <source :src="url" type="video/mp4" />
            </video>
        </div>
    </transition>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import velocity from 'velocity-animate';

export default {
    name: 'VideoGalleryPlayer',

    data() {
        return {
            url: null,
        };
    },

    methods: {
        ...mapMutations(['setActorVideoPlaying']),

        enter(el, done) {
            Velocity(el, { opacity: 1 }, { duration: 300, easing: 'easeInBack' }, { complete: done });
        },

        leave(el, done) {
            Velocity(
                el,
                { opacity: 0, pointerEvents: 'none' },
                { duration: 300, easing: 'easeInBack' },
                { complete: done }
            );
        },

        close() {
            this.$refs.video.pause();
            this.setActorVideoPlaying(null);
        },
    },

    computed: {
        ...mapGetters(['getActorVideoPlaying']),
    },

    watch: {
        getActorVideoPlaying(val) {
            if (val) {
                this.url = val.file;
            }
        },
    },
};
</script>
<style lang="less" scoped>
@import '~@variables';

[component='VideoGalleryPlayer'] {
    .flex-center;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 95555;
    width: 100%;
    background: black;
    padding: 20px;
    border-radius: 20px;
    overflow: hidden;
    max-width: 920px;

    @media (max-width: 768px) {
        top: 80px;
        bottom: 0;
        border-radius: 0;
        height: auto;
    }

    &.fade-enter-active,
    &.fade-leave-active {
        transition: 0.5s;
    }
    &.fade-enter, &.fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
        transform: translateX(-50%) scale(0.9);
    }

    video {
        width: 100%;
        height: 100%;
    }

    .close {
        position: absolute;
        right: 10px;
        top: 10px;
        box-shadow: 0 0 20px 6px black;
        background: rgba(0, 0, 0, 30%) !important;
        z-index: 9999;
    }
}
</style>
